module.exports = __webpack_public_path__ + "img/advantage-5.ecfe1f0a.png";